$(function() {

  var siteSticky = function() {
		$(".js-sticky-header").sticky({topSpacing:0});
	};
	siteSticky();

	var siteMenuClone = function() {

		$('.js-clone-nav').each(function() {
			var $this = $(this);
			$this.clone().attr('class', 'site-nav-wrap').appendTo('.site-mobile-menu-body');
		});


		setTimeout(function() {
			
			var counter = 0;
      $('.site-mobile-menu .has-children').each(function(){
        var $this = $(this);
        
        $this.prepend('<span class="arrow-collapse collapsed">');

        $this.find('.arrow-collapse').attr({
          'data-toggle' : 'collapse',
          'data-target' : '#collapseItem' + counter,
        });

        $this.find('> ul').attr({
          'class' : 'collapse',
          'id' : 'collapseItem' + counter,
        });

        counter++;

      });

    }, 1000);

		$('body').on('click', '.arrow-collapse', function(e) {
      var $this = $(this);
      if ( $this.closest('li').find('.collapse').hasClass('show') ) {
        $this.removeClass('active');
      } else {
        $this.addClass('active');
      }
      e.preventDefault();  
      
    });

		$(window).resize(function() {
			var $this = $(this),
				w = $this.width();

			if ( w > 768 ) {
				if ( $('body').hasClass('offcanvas-menu') ) {
					$('body').removeClass('offcanvas-menu');
				}
			}
		})

		$('body').on('click', '.js-menu-toggle', function(e) {
			var $this = $(this);
			e.preventDefault();

			if ( $('body').hasClass('offcanvas-menu') ) {
				$('body').removeClass('offcanvas-menu');
				$this.removeClass('active');
			} else {
				$('body').addClass('offcanvas-menu');
				$this.addClass('active');
			}
		}) 

		// click outisde offcanvas
		$(document).mouseup(function(e) {
	    var container = $(".site-mobile-menu");
	    if (!container.is(e.target) && container.has(e.target).length === 0) {
	      if ( $('body').hasClass('offcanvas-menu') ) {
					$('body').removeClass('offcanvas-menu');
				}
	    }
		});
	}; 
	siteMenuClone();

});


$('.product_item').hover(function (e) { // mouse-in 
    $(this).find('.product-card_buttons').css("opacity", "1");
},
    function () { // mouse-out
        $(this).find('.product-card_buttons').css("opacity", "0");
    }
)
	

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

var formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

//Add to cart ajax
const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

addToCartForms.forEach((form) => {
  form.addEventListener("submit", async (event) => {
    // Prevent normal submission
    event.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get new cart object
    const res = await fetch("/cart.json");
    const cart = await res.json();

    // Update cart count
    document.querySelectorAll(".cart-count").forEach((el) => {
      el.textContent = cart.item_count;
    });

    // Display message
    //const message = document.createElement("p");
    //message.classList.add("added-to-cart");
    //message.textContent = "Added to cart!";
    //form.appendChild(message);
  });
});
    

//CART DRAWER
function openCartDrawer() {
	document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  }
  
  function closeCartDrawer() {
	document
	  .querySelector(".cart-drawer")
	  .classList.remove("cart-drawer--active");
  }
  
  function updateCartItemCounts(count) {
	document.querySelectorAll(".cart-count").forEach((el) => {
	  el.textContent = count;
	});
  }
  
  async function updateCartDrawer() {
	const res = await fetch("/?section_id=cart-drawer");
	const text = await res.text();
	const html = document.createElement("div");
	html.innerHTML = text;
  
	const newBox = html.querySelector(".cart-drawer").innerHTML;
  
	document.querySelector(".cart-drawer").innerHTML = newBox;
  
	addCartDrawerListeners();
  }
  
  function addCartDrawerListeners() {
	// Update quantities
	document
	  .querySelectorAll(".cart-drawer-quantity-selector button")
	  .forEach((button) => {
		button.addEventListener("click", async () => {
		  // Get line item key
		  const rootItem =
			button.parentElement.parentElement.parentElement.parentElement
			  .parentElement;
		  const key = rootItem.getAttribute("data-line-item-key");
  
		  // Get new quantity
		  const currentQuantity = Number(
			button.parentElement.querySelector("input").value
		  );
		  const isUp = button.classList.contains(
			"cart-drawer-quantity-selector-plus"
		  );
		  const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
  
		  // Ajax update\
		  const res = await fetch("/cart/update.js", {
			method: "post",
			headers: {
			  Accept: "application/json",
			  "Content-Type": "application/json",
			},
			body: JSON.stringify({ updates: { [key]: newQuantity } }),
		  });
		  const cart = await res.json();
  
		  updateCartItemCounts(cart.item_count);
  
		  // Update cart
		  updateCartDrawer();
		});
	  });
  
	document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
	  e.stopPropagation();
	});
  
	document
	  .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
	  .forEach((el) => {
		el.addEventListener("click", () => {
		  console.log("closing drawer");
		  closeCartDrawer();
		});
	  });
  }
  
  addCartDrawerListeners();
  
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
	form.addEventListener("submit", async (e) => {
	  e.preventDefault();
  
	  // Submit form with ajax
	  await fetch("/cart/add", {
		method: "post",
		body: new FormData(form),
	  });
  
	  // Get cart count
	  const res = await fetch("/cart.js");
	  const cart = await res.json();
	  updateCartItemCounts(cart.item_count);
  
	  // Update cart
	  await updateCartDrawer();
  
	  // Open cart drawer
	  openCartDrawer();
	});
  });
  
  document.querySelectorAll('a[href="/cart"]').forEach((a) => {
	a.addEventListener("click", (e) => {
	  e.preventDefault();
	  openCartDrawer();
	});
  });



$("#showModalButton").on("click", function() {
    // Show the full-screen modal
    $("#fullScreenModal").modal("show");
});

$("#showModalButtonMobile").on("click", function() {
    // Show the full-screen modal
    $("#fullScreenModal").modal("show");
});

$("#recoverAccount").on("click", function() {
    // Show the full-screen modal
    $("#forgotPassword").modal("show");
});

//Zeynep Menu

$(function() {
    // init zeynepjs side menu
    var zeynep = $('.zeynep').zeynep({
      opened: function () {
        // log
        console.log('the side menu opened')
      },
      closed: function () {
        // log
        console.log('the side menu closed')
      }
    })

    // dynamically bind 'closing' event
    zeynep.on('closing', function () {
      // log
      console.log('this event is dynamically binded')
    })

    // handle zeynepjs overlay click
    $('.zeynep-overlay').on('click', function () {
      zeynep.close()
    })

    // handle zeynepjs overlay click
    $('.btn-close').on('click', function () {
        zeynep.close()
      })

    // open zeynepjs side menu
    $('.btn-open').on('click', function () {
      zeynep.open()
    })

})